import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/project.svg
 */
const IconProject: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.54 16.93L16 18.613l6-2.915v-8.29L16 4.48l-6 2.926v3.046l1 1.87V8.449l5 2.43 5-2.43v6.623l-5 2.43-3.25-1.58.315.679-.525.33zM16 5.594l4.286 2.09L16 9.767l-4.286-2.082L16 5.594z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 17.796v-7.278h1v7.278h-1zM2 16.52l6 3 6-3-6-10-6 10zm5.5-7.224l-4.087 6.812L7.5 18.15V9.296zm1 0v8.855l4.087-2.043L8.5 9.296z"
      fill="currentColor"
    />
  </svg>
);

export default IconProject;
